// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@flip/XDL/PreStyle/typography";
import { xScreen } from "@flip/XDL/Utilities";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { css } from "styled-components";

interface XProductPartNumbersStyles {
    default: {
        label: TypographyPresentationProps;
        value: TypographyPresentationProps;
    };
    large: {
        label: TypographyPresentationProps;
        value: TypographyPresentationProps;
    };
}

const xProductPartNumbersStyles: XProductPartNumbersStyles = {
    default: {
        label: {
            size: 12,
            weight: fontConfig.weight.semiBold,
            transform: "capitalize",
            color: "text",
            css: css`
                letter-spacing: 0;
                line-height: 13px;
                margin-right: 4px;
                flex-shrink: 0;
                display: inline-block;
                &:after {
                    content: ":";
                }
            `,
        },
        // XNG-Changes: FLIP-782
        value: {
            size: 12,
            weight: fontConfig.weight.regular,
            ellipsis: true,
            color: "text",
            css: css`
                letter-spacing: 0;
                line-height: 13px;
                ${wrapInContainerStyles}
                ${xScreen("lte", "xs")} {
                    word-wrap: break-word;
                    word-break: break-word;
                    text-overflow: unset;
                    white-space: normal;
                }
            `,
        },
    },
    large: {
        label: {
            size: 14,
            weight: fontConfig.weight.semiBold,
            transform: "capitalize",
            color: "text",
            css: css`
                letter-spacing: 0;
                line-height: 22px;
                margin-right: 8px;
                flex-shrink: 0;
                display: inline-block;

                &:after {
                    content: ":";
                }

                ${xScreen("gte", "sm")} {
                    width: 138px;
                }
            `,
        },
        // XNG-Changes: FLIP-783,
        value: {
            size: 14,
            weight: fontConfig.weight.regular,
            ellipsis: true,
            color: "text",
            css: css`
                letter-spacing: 0;
                line-height: 22px;
                ${wrapInContainerStyles}
                ${xScreen("lte", "xs")} {
                    word-wrap: break-word;
                    word-break: break-word;
                    text-overflow: unset;
                    white-space: normal;
                }
            `,
        },
    },
};

export default xProductPartNumbersStyles;
